import { useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { TextField, Card } from "./Field";
import { saveSettings } from "../lib/storage";

const opcije = [
  { key: "autobusi", title: "Autobusi (organizirani prijevoz)", desc: "Za škole s organiziranim prijevozom učenika. Uključuje tab Autobusi u nastavnom danu." },
  { key: "smjene", title: "Rad u smjenama", desc: "Za škole koje rade u jutarnjoj i popodnevnoj smjeni. Dodaje odabir smjene u osnovne podatke." },
  { key: "podrucneSkole", title: "Područne škole", desc: "Za matične škole s područnim školama. Dodaje polje za lokaciju dežurstva." },
  { key: "dezurniUcenici", title: "Dežurni učenici", desc: "Za škole u kojima dežuraju i učenici. Dodaje polje za upis dežurnih učenika." },
];

export default function Postavke({ settings, onSave }) {
  const [form, setForm] = useState(settings);

  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  const toggle = (k) => setForm((f) => ({ ...f, opcije: { ...f.opcije, [k]: !f.opcije[k] } }));

  const handleSave = () => {
    saveSettings(form);
    onSave(form);
    toast.success("Postavke su spremljene u vaš preglednik");
  };

  return (
    <div className="animate-fade-in" data-testid="postavke-view">
      <div className="mb-6 border-b border-slate-200 pb-5">
        <h1 className="font-heading text-xl font-extrabold tracking-tight text-slate-900 sm:text-2xl">Postavke škole</h1>
        <p className="mt-1 text-sm text-slate-500">Prilagodite aplikaciju svojoj školi. Postavke se spremaju samo u vaš preglednik.</p>
      </div>

      <div className="grid max-w-3xl gap-5">
        <Card title="Podaci o školi" subtitle="Prikazuju se u aplikaciji i na PDF izvještaju">
          <TextField label="Naziv škole" value={form.nazivSkole} onChange={set("nazivSkole")} testId="form-skola-naziv-input" placeholder='npr. Osnovna škola "Antunovac"' />
          <div className="grid gap-4 sm:grid-cols-2">
            <TextField label="Mjesto" value={form.mjesto} onChange={set("mjesto")} testId="form-skola-mjesto-input" placeholder="npr. Antunovac" />
            <TextField label="Ime i prezime ravnatelja" value={form.ravnatelj} onChange={set("ravnatelj")} testId="form-ravnatelj-input" placeholder="Ime i prezime" />
          </div>
          <TextField label="E-mail ravnatelja" type="email" value={form.emailRavnatelja} onChange={set("emailRavnatelja")} testId="form-ravnatelj-email-input" placeholder="ravnatelj@skola.hr" hint="Koristi se za gumb Pošalji ravnatelju" />
        </Card>

        <Card title="Opcije dežuranja" subtitle="Svaka škola je drukčija, uključite samo ono što vam treba">
          <div className="space-y-3">
            {opcije.map((o) => (
              <label key={o.key} className="flex cursor-pointer items-start justify-between gap-4 rounded-xl border border-slate-200/80 bg-slate-50/50 p-4 transition-colors hover:border-sky-200">
                <div>
                  <p className="text-sm font-semibold text-slate-800">{o.title}</p>
                  <p className="mt-0.5 text-xs leading-relaxed text-slate-500">{o.desc}</p>
                </div>
                <button
                  type="button"
                  role="switch"
                  aria-checked={form.opcije[o.key]}
                  data-testid={`postavke-opcija-${o.key}`}
                  onClick={() => toggle(o.key)}
                  className={`relative mt-0.5 h-6 w-11 shrink-0 rounded-full transition-colors ${form.opcije[o.key] ? "bg-sky-600" : "bg-slate-300"}`}
                >
                  <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-all ${form.opcije[o.key] ? "left-[22px]" : "left-0.5"}`} />
                </button>
              </label>
            ))}
          </div>
        </Card>

        <div>
          <button
            data-testid="postavke-spremi-btn"
            onClick={handleSave}
            className="inline-flex items-center gap-2 rounded-xl bg-sky-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-sky-700 active:scale-[0.98]"
          >
            <Save className="h-4 w-4" /> Spremi postavke
          </button>
        </div>
      </div>
    </div>
  );
}
